import '@hotwired/turbo-rails'
import '../controllers'

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js', { scope: '/' })
      .catch((error) => console.warn('Não foi possível registrar o aplicativo para uso offline.', error))
  }, { once: true })
}
